module.exports = __webpack_public_path__ + "static/media/br.08b00895.svg";